import React, { useState } from 'react';
import ReportedActivatedList from './components/ReportedActivatedList';
import ActionBar from '../layout/ActionBar';
import UploadActivated from './slideout/UploadActivated';
import SlidingPane from 'react-sliding-pane';
import Button from '../common/Button';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../util/pageTitle';

function ReportedActivated() {
  usePageTitle(['Reported activated', 'Keys']);
  const [reload, setReload] = useState<any>();
  const [uploadKeysSlideoutOpen, setUploadKeysSlideoutOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <ActionBar>
        <Button
          className="btn btn-primary"
          onClick={() => setUploadKeysSlideoutOpen(true)}
          text={t('Upload activated keys')}
        />
      </ActionBar>
      <ReportedActivatedList reload={reload} />
      <SlidingPane
        isOpen={uploadKeysSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => {
          setUploadKeysSlideoutOpen(false);
          setReload(new Date());
        }}
      >
        <UploadActivated
          done={() => {
            setUploadKeysSlideoutOpen(false);
            setReload(new Date());
          }}
          cancel={() => setUploadKeysSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  );
}

export default ReportedActivated;
